module.exports = __webpack_public_path__ + "static/media/merilinmonro_natal.16ea3b3a.jpg";